
import { defineComponent } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

import Loading from "@/components/loading.vue";

declare const window: any;

export default defineComponent({
  name: "App",
  components: {
    Loading,
  },
  setup() {
    const store = useStore();

    const { locale } = useI18n();

    const init = () => {
      if (typeof window.acredoCatalog !== "undefined") {
        const allowedCountries = ["be", "benl", "de", "us", "ee"];
        const allowedLanguages = ["de", "en", "nl", "ee"];

        if (allowedCountries.includes(window.acredoCatalog.country)) {
          store.commit("setCountryCode", window.acredoCatalog.country);
        } else {
          store.commit("setCountryCode", "de");
        }

        if (allowedLanguages.includes(window.acredoCatalog.language)) {
          locale.value = window.acredoCatalog.language;
        } else {
          locale.value = "de";
        }
      }
    };

    init();
  },
});
